import backgroundRemovalManager from '../../../utils/background-removal-manager';
import BackgroundRemoval from '../../../modules/background-removal';
import imagesFactory from '../../../factory/images';

module.exports = _.extend({
  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;
  },

  flipVertical: function (element) {
    if ($('#' + element.id + '-loader').length) {
      this.canvas.call('advice.show', 'image-flip-disabled');
      return;
    }

    this.canvas.selectOnly([element]);
    INKIVE.DesignFacade.set({ flipped: { vertical: true } });
  },

  flipHorizontal: function (element) {
    if ($('#' + element.id + '-loader').length) {
      this.canvas.call('advice.show', 'image-flip-disabled');
      return;
    }

    this.canvas.selectOnly([element]);
    INKIVE.DesignFacade.set({ flipped: { horizontal: true } });
  },

  removeBackgroundAndEdit: async function (imageUrl) {
    try {
      const { id, secret } = await BackgroundRemoval.API.fetchImageData(imageUrl);
      const status = await BackgroundRemoval.SDK.editBackground(id, secret);

      if (status !== 'result-generated') return;

      return await BackgroundRemoval.API.fetchGeneratedImageUrl(id);
    } catch (error) {
      if (INKIVE.C.DEBUG) {
        console.warn('[Background Removal]', error);
      }

      return null;
    }
  },

  removeBackground: async function (elem) {
    elem = elem || this.canvas.getSelectedElems()[0];

    const source = INKIVE.DesignFacade.get(elem.id).source.url;
    const isBase64 = !source || source === '<data>';

    if (isBase64) {
      this.canvas.call('advice.show', 'save-first');
      this.trigger('remove_background.error', elem.id);
      return;
    }

    this.canvas.selectOnly([elem]);
    this.trigger('remove_background.start', elem.id);

    try {
      const isEdit = INKIVE.C.FEATURE_FLAG.brand_assets.includes('use_clipping_magic');
      const { original, largeweb } = imagesFactory.getAllImageVersions(source);
      const imageUrl = isEdit ? largeweb || original : original;
      elem.removeAttribute('data-hash');

      const urlEdit = isEdit && await this.removeBackgroundAndEdit(imageUrl);
      const url = (urlEdit || urlEdit === undefined) // undefined means edit was skipped
        ? urlEdit
        : await backgroundRemovalManager.removeBackground(imageUrl);

      if (!url) {
        return this.trigger('remove_background.skip', elem.id);
      }

      INKIVE.DesignFacade.set(elem.id, {
        source: { url, preload: false },
        keep_box_size: true,
        background_removed: true
      });

      this.trigger('remove_background.success', elem.id);
    } catch (err) {
      this.trigger('remove_background.error', elem.id);
    }
  }
}, Backbone.Events);
